<a
  class="d-flex align-items-center pointer text-decoration-none"
  (click)="goBack()"
  style="outline: none"
  href="javascript:void(0);"
>
  <img loading="lazy" src="assets/icons/back-icon.svg" class="me-2" />
  <div class="fw-700 font-14 text-muted">{{text}}</div>
</a>
